import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { CallButton, QuoteButton, SectionLabel } from "../components/Shared";

const FAQS = [
  {
    q: "How quickly can you arrive?",
    a: "Response time depends on your location, traffic and availability, but we aim to get help to you as quickly as possible.",
  },
  {
    q: "Do you recover vans?",
    a: "Yes, we can support vans and light commercial vehicles.",
  },
  {
    q: "Can you take my vehicle to a garage?",
    a: "Yes. We can recover your vehicle to your preferred garage, home or another agreed location.",
  },
  {
    q: "Do you offer jump starts?",
    a: "Yes, we can assist with flat batteries and jump starts where suitable.",
  },
  {
    q: "Can you help after a tyre blowout?",
    a: "Yes, we can help with tyre-related breakdowns and recovery if the vehicle cannot be driven safely.",
  },
  {
    q: "Do I need to be a member?",
    a: "No. ExpressBreakdown can be contacted when you need support.",
  },
];

export default function FAQ() {
  return (
    <div data-testid="faq-page">
      <section className="border-b border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 sm:py-32">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
            <div className="lg:col-span-5">
              <SectionLabel>FAQ</SectionLabel>
              <h1
                data-testid="faq-headline"
                className="mt-6 text-4xl sm:text-5xl lg:text-6xl font-display font-extrabold tracking-tighter leading-[0.95]"
              >
                Questions, answered.
              </h1>
              <p className="mt-6 text-base text-white/70 leading-relaxed max-w-md">
                If you need clarification about our recovery service, you'll
                likely find it here. If not, call us directly.
              </p>
              <div className="mt-10 flex flex-col sm:flex-row gap-4">
                <CallButton testId="faq-call-btn" />
                <QuoteButton testId="faq-quote-btn" />
              </div>
            </div>
            <div className="lg:col-span-7">
              <Accordion
                type="single"
                collapsible
                className="border-t border-white/10"
                data-testid="faq-accordion"
              >
                {FAQS.map((f, i) => (
                  <AccordionItem
                    key={f.q}
                    value={`item-${i}`}
                    data-testid={`faq-item-${i}`}
                    className="border-b border-white/10 border-t-0"
                  >
                    <AccordionTrigger className="text-left py-6 font-display font-bold text-lg sm:text-xl hover:text-brand hover:no-underline tracking-tight">
                      <span className="flex items-start gap-5">
                        <span className="text-brand text-sm font-bold tracking-wider mt-1 shrink-0">
                          {String(i + 1).padStart(2, "0")}
                        </span>
                        {f.q}
                      </span>
                    </AccordionTrigger>
                    <AccordionContent className="pb-6 pl-12 text-sm sm:text-base text-white/70 leading-relaxed">
                      {f.a}
                    </AccordionContent>
                  </AccordionItem>
                ))}
              </Accordion>
            </div>
          </div>
        </div>
      </section>

      <section className="bg-brand text-black">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6">
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-display font-extrabold tracking-tight">
            Still have questions?
          </h2>
          <a
            href="tel:+447717759310"
            data-testid="faq-cta-call"
            className="inline-flex items-center gap-3 bg-black text-brand font-bold uppercase tracking-wider px-7 py-5"
          >
            Call ExpressBreakdown
          </a>
        </div>
      </section>
    </div>
  );
}
